function getNewUrl(page){
  // 获取当前 URL
  const currentUrl = window.location.href;
  
  // 创建 URL 对象
  const url = new URL(currentUrl);
  
  // 获取 URLSearchParams 对象
  const params = url.searchParams;
  
  // 修改 page 参数的值
  const newPageValue = page;
  
  params.set('page', newPageValue);
  
  // 更新 URL 的查询字符串
  url.search = params.toString();
  
  return url.toString();
}

function getPaginationHtml(currentPage, totalCount, pageSize, perIcon, lastIcon, isRemote) {
  currentPage = parseInt(currentPage);
  const totalPages = Math.ceil(totalCount / pageSize);
  if(totalPages == 1){
    return '';
  }
  // 只返回 data-page 属性，干净安全
  const getPageAttr = (page) => isRemote ? `data-page="${page}"` : '';
  let preHTML = ''
  if(currentPage > 1){
    preHTML = `
      <li>
        <a href="${isRemote ? 'javascript:void(0)' :  getNewUrl(currentPage-1) }" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" 
        aria-label="Previous page" ${getPageAttr(currentPage - 1)}>
          <span class="svg-wrapper">${perIcon}</span>
        </a>
      </li>`;
  }
  let buttonHtml = '';
  let hasLeft = false;
  let hasRigth = false;
  for (let i = 1; i <= totalPages; i++) {
    if(i == 1 || i == currentPage || i == totalPages){
      if(i == currentPage){
        buttonHtml += `
          <li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="${i}">
            ${i}
          </a></li>
        `;
      }else{
        buttonHtml += `
          <li><a href="${isRemote ? 'javascript:void(0)' :  getNewUrl(i)}" class="pagination__item link" aria-label="${i}" ${getPageAttr(i)}>
            ${i}
          </a></li>
        `;
      }
      continue;
    }
    if(i < currentPage-2){
      if(hasLeft){
        continue;
      }else{
        buttonHtml += `<li><span class="pagination__item">…</span></li>`;
        hasLeft = true;
      }
    }else if(i < currentPage){
      buttonHtml += `
          <li><a href="isRemote ? 'javascript:void(0)' :  ${getNewUrl(i)}" class="pagination__item link" aria-label="${i}" ${getPageAttr(i)}>
            ${i}
          </a></li>
        `;
    }
    if(i > currentPage+2){
      if(hasRigth){
        continue;
      }else{
        buttonHtml += `<li><span class="pagination__item">…</span></li>`;
        hasRigth = true;
      }
    }else if(i > currentPage){
      buttonHtml += `
          <li><a href="${isRemote ? 'javascript:void(0)' : getNewUrl(i)}" class="pagination__item link" aria-label="${i}" ${getPageAttr(i)}>
            ${i}
          </a></li>
        `;
    }
  }
  let lastHTML = ''
  if(currentPage < totalPages){
    lastHTML = `
      <li>
        <a href="${isRemote ? 'javascript:void(0)' : getNewUrl(currentPage+1) }" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" 
        aria-label="Next page" ${getPageAttr(currentPage + 1)}>
          <span class="svg-wrapper">${lastIcon}</span>
        </a>
      </li>`;
  }

  const pageHTML = `
      <div class="pagination-wrapper" data-page="${ currentPage }">
        <nav class="pagination" role="navigation" aria-label="Pagination">
          <ul class="pagination__list list-unstyled" role="list">
            ${ preHTML }
            ${buttonHtml}
            ${lastHTML}
          </ul>
        </nav>
      </div>
  `;
  return pageHTML;
}